import { mutate } from 'swr';

export const miniCartsKey = '/action/cart/getMiniCarts';

// Right after login the customer's carts can briefly be missing from the getMiniCarts response
// (the cart-customer association hasn't propagated yet). Wait a moment before revalidating.
export const mutateMiniCarts = async (
  delayMs = 400,
): Promise<{ isError?: boolean; data?: unknown[] } | undefined> => {
  await new Promise((resolve) => setTimeout(resolve, delayMs));
  return (await mutate(miniCartsKey)) as { isError?: boolean; data?: unknown[] } | undefined;
};

export const invalidateCartAndMiniCarts = async (
  getCartKey: (cartId?: string) => any,
  cartId: string,
  cartResponse?: any,
) => {
  if (cartResponse) {
    await mutate(getCartKey(cartId), cartResponse);
  } else {
    await mutate(getCartKey(cartId));
  }

  await mutate(miniCartsKey);
};
